var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.60417 20.5972C7.9947 20.9878 8.62786 20.9878 9.01839 20.5972L15.3823 14.2333C15.7729 13.8428 15.7729 13.2096 15.3823 12.8191C14.9918 12.4285 14.3587 12.4285 13.9681 12.8191L8.31128 18.4759L2.65442 12.8191C2.2639 12.4285 1.63074 12.4285 1.24021 12.8191C0.849687 13.2096 0.849687 13.8428 1.24021 14.2333L7.60417 20.5972ZM7.31128 0.864258L7.31128 19.8901L9.31128 19.8901L9.31128 0.864258L7.31128 0.864258Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/Arrow 1.4edd32a4efc351e6839877fc47298b43.svg";
export { ForwardRef as ReactComponent };